/**
 * Project : workspace
 * File    : MembershipRow.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.customer.membership

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Home
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp

import com.parmartechnologies.commerce.feature.customer.viewModel.CustomerViewModel
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import common.asset.ImageAsset
import component.image.FriendlyIcon
import io.github.alexzhirkevich.qrose.oned.BarcodeType
import io.github.alexzhirkevich.qrose.oned.rememberBarcodePainter
import presentation.screens.common.auth.LoginScreen
import theme.ThemeColor

@Composable
/**
 * Executes the membership row operation.
 *
 * @receiver TODO
 * @param authViewModel The auth view model.
 * @param viewModel The view model.
 * @return Unit – no return value.
 */
fun MembershipRow(authViewModel: AuthViewModel, viewModel: CustomerViewModel) {
    
    val customer = viewModel.customer.collectAsState()
    val user = authViewModel.authUser.collectAsState()
    if (user.value.MobileNumber.isNotEmpty() && user.value.DialCode.isNotEmpty()) {
        viewModel.loadMembership(
            mobile = user.value.MobileNumber, dialCode = user.value.DialCode
        )
    }
    if (!customer.value?.Barcode.isNullOrEmpty()) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .height(70.dp)
                .background(Color(0x8DB3B0B0), shape = RoundedCornerShape(10.dp))
                .clip(RoundedCornerShape(10.dp))
                .clickable {
                    val screen = MembershipDetailsScreen()
                    screen.viewModel = viewModel
                    screen.authViewModel = authViewModel
//                    navigator?.push(screen)
                }
                .padding(5.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(
                modifier = Modifier
                    .padding(start = 20.dp)
            ) {
                Text(
                    "Hello " + authViewModel.authUser.value.Name,
                    modifier = Modifier.weight(0.2f)
                )
                Text(
                    "Welcome back",
                    modifier = Modifier.weight(0.2f)
                )
            }
            Row(
                modifier = Modifier
                    .width(120.dp)
                    .height(50.dp)
                    .background(Color(0xFFFFFFFF), shape = RoundedCornerShape(10.dp))
                    .clip(RoundedCornerShape(10.dp))
                    .clickable {
                        val screen = MembershipDetailsScreen()
                        screen.viewModel = viewModel
                        screen.authViewModel = authViewModel
//                        navigator?.push(screen)
                    }
                    .padding(5.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Image(
                    painter = rememberBarcodePainter(customer.value?.Barcode.toString(), BarcodeType.Code128),
                    contentDescription = "Barcode for invoice ${customer.value?.Barcode}",
                    modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.6f)
                )
            }
            FriendlyIcon(ImageAsset.arrowRightIcon)
        }
    } else {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .height(70.dp)
                .background(Color(0x8DB3B0B0), shape = RoundedCornerShape(10.dp))
                .clip(RoundedCornerShape(10.dp))
                .clickable {
                    if (authViewModel.isLoggedIn.value) {
                        val screen = MembershipDetailsScreen()
                        screen.viewModel = viewModel
                        screen.authViewModel = authViewModel
//                        navigator?.push(screen)
                    } else {
                        val screen = LoginScreen()
//                        navigator?.push(screen)
                    }
                }
                .padding(5.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                Icons.Default.Home,
                contentDescription = "Home",
                modifier = Modifier.weight(0.05f), tint = ThemeColor.shared().Green
            )
            Text("Click To check Membership", modifier = Modifier.weight(0.2f))
            FriendlyIcon(ImageAsset.arrowRightIcon)
        }
    }
}